import * as React from "react";
import classNames from "classnames";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';

export interface DivBoxProps {
    children?: React.ReactNode;
    weight?: 'normal' | 'lighter' | 'bolder';
    label?: boolean;
    nested?: boolean;
    noPadding?: boolean;
}

const DivBox = (props: DivBoxProps & WithStyles<typeof styles>) => {
    const { children, weight, label, noPadding, nested, classes } = props;
    const className = classNames([
        { [classes.root]: true },
        { [classes.label]: label === true },
        { [classes.bolder]: weight === 'bolder' },
        { [classes.lighter]: weight === 'lighter' },
        { [classes.nested]: nested === true },
        { [classes.noPadding]: noPadding === true },
    ]);
    return <div className={className}>
        {children}
    </div>
}



export const styles = (theme: Theme) => createStyles({
    root: {
        paddingTop: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        //fontSize: '1.0rem'
    },
    nested: {
        paddingLeft: theme.spacing.unit * 2,
    },
    label: {
        //fontSize: '0.9rem',
        color: theme.palette.primary.main,
    },
    lighter: {
        fontWeight: 'lighter',
        fontSize: '0.8rem'
    },
    bolder: {
        fontWeight: 'bolder'
    },
    noPadding: {
        padding: 0
    },
});


export default withStyles(styles)(DivBox);